import { Breakpoint, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PopupComponent } from './PopupComponent';

interface ConfirmProps {
  isOpen: boolean;
  fullWidth?: boolean;
  maxWidth?: Breakpoint | false;
  title?: ReactNode;
  className?: string;
  message?: string;
  confirmDisabled?: boolean;
  confirmButtonText?: string;
  actions?: ReactNode;
  onCancel?(): void;
  onConfirm?(): void;
  btnClassName?: string;
  cancelButtonText?: string;
}

export function Confirm(props: PropsWithChildren<ConfirmProps>) {
  const { actions, confirmDisabled, children, isOpen, message, onCancel, onConfirm, className, btnClassName } = props;
  const { t } = useTranslation();

  return (
    <PopupComponent
      fullWidth={props.fullWidth}
      open={isOpen}
      child
      maxWidth={props.maxWidth ?? 'md'}
      className={className}
      onKeyDown={(event: any) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          onConfirm?.();
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          onCancel?.();
        }
      }}
    >
      <DialogTitle>{props.title ?? t('Confirm')}</DialogTitle>
      <DialogContent>
        {message && <Typography>{message}</Typography>}
        {children}
      </DialogContent>
      <DialogActions>
        {onCancel ? (
          <Button className={btnClassName} onClick={onCancel}>
            {props.cancelButtonText ?? t('Cancel')}
          </Button>
        ) : null}
        {onConfirm ? (
          <Button disabled={confirmDisabled} onClick={onConfirm}>
            {props.confirmButtonText ?? t('OK')}
          </Button>
        ) : null}
        {actions}
      </DialogActions>
    </PopupComponent>
  );
}
